// src/screens/SettingsScreen.jsx
import { useState } from "react";
import { C } from "../styles/tokens";
import { Icon } from "../components/UI";

export default function SettingsScreen() {
  const [s, setS] = useState({
    emailAlerts:        true,
    smsAlerts:          false,
    donorNotif:         true,
    staffNotif:         true,
    criticalThreshold:  5,
    lang:               "English",
    theme:              "Dark",
  });

  const tog = (k) => setS((p) => ({ ...p, [k]: !p[k] }));

  const Section = ({ title, children }) => (
    <div className="card" style={{ padding: 24, marginBottom: 16 }}>
      <div className="syne" style={{ fontSize: 15, fontWeight: 800, marginBottom: 18, color: C.text }}>{title}</div>
      {children}
    </div>
  );

  const Row = ({ label, sub, togKey, val, children }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 0", borderBottom: `1px solid ${C.border}` }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: C.text }}>{label}</div>
        {sub && <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{sub}</div>}
      </div>
      {togKey ? (
        <label className="toggle">
          <input type="checkbox" checked={val} onChange={() => tog(togKey)} />
          <span className="toggle-slider" />
        </label>
      ) : children}
    </div>
  );

  return (
    <div className="fade-up" style={{ padding: 24, maxWidth: 640 }}>
      {/* Notifications */}
      <Section title="Notifications">
        <Row label="Email Alerts"     sub="Receive critical alerts via email"         togKey="emailAlerts" val={s.emailAlerts} />
        <Row label="SMS Alerts"       sub="Get SMS for emergency requests"            togKey="smsAlerts"   val={s.smsAlerts}   />
        <Row label="Notify Donors"    sub="Auto-alert nearby donors for new requests" togKey="donorNotif"  val={s.donorNotif}  />
        <Row label="Staff Notifications" sub="Alert blood bank team on new requests"  togKey="staffNotif"  val={s.staffNotif}  />
      </Section>

      {/* Inventory */}
      <Section title="Inventory">
        <Row label="Critical Stock Threshold" sub="Alert when units fall below this number">
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button
              onClick={() => setS((p) => ({ ...p, criticalThreshold: Math.max(1, p.criticalThreshold - 1) }))}
              style={{ width: 30, height: 30, background: "rgba(198,40,40,.1)", border: "1px solid rgba(198,40,40,.3)", borderRadius: 7, color: C.red, cursor: "pointer", fontSize: 16 }}
            >−</button>
            <span style={{ width: 32, textAlign: "center", fontWeight: 700, color: C.text }}>{s.criticalThreshold}</span>
            <button
              onClick={() => setS((p) => ({ ...p, criticalThreshold: Math.min(20, p.criticalThreshold + 1) }))}
              style={{ width: 30, height: 30, background: "rgba(198,40,40,.1)", border: "1px solid rgba(198,40,40,.3)", borderRadius: 7, color: C.red, cursor: "pointer", fontSize: 16 }}
            >+</button>
          </div>
        </Row>
      </Section>

      {/* Preferences */}
      <Section title="Preferences">
        <Row label="Language">
          <select
            className="inp"
            style={{ paddingLeft: 12, width: "auto", minWidth: 130 }}
            value={s.lang}
            onChange={(e) => setS((p) => ({ ...p, lang: e.target.value }))}
          >
            {["English", "Hindi", "Gujarati"].map((l) => <option key={l}>{l}</option>)}
          </select>
        </Row>
        <Row label="Theme">
          <select
            className="inp"
            style={{ paddingLeft: 12, width: "auto", minWidth: 130 }}
            value={s.theme}
            onChange={(e) => setS((p) => ({ ...p, theme: e.target.value }))}
          >
            {["Dark", "System"].map((t) => <option key={t}>{t}</option>)}
          </select>
        </Row>
      </Section>

      <button className="btn-primary" style={{ maxWidth: 240 }}>
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <Icon name="check" size={16} color="#fff" />Save Settings
        </span>
      </button>
    </div>
  );
}